export enum modeofnotification {
    Phone = 1,
    Email = 2,
    Both = 3
}